import React from "react";
import { Link, useLocation } from "react-router-dom";
import BrandMark from "../components/BrandMark";
import { Button } from "../components/ui/button";
import { suggestRoutes } from "../lib/routeRegistry";
import { Home, Search, ArrowRight, BookOpen } from "lucide-react";
import { useAuth } from "../lib/auth";
import { homeRouteFor } from "../lib/roleHome";

export default function NotFound() {
  const location = useLocation();
  const { user } = useAuth();
  const suggestions = suggestRoutes(location.pathname);
  const homePath = user ? homeRouteFor(user) : "/";

  return (
    <div className="min-h-screen bg-erf-dark text-erf-cream flex flex-col items-center justify-center p-6" data-testid="not-found-page">
      <div className="max-w-lg w-full text-center space-y-6">
        <div className="flex justify-center opacity-90"><BrandMark size={120} /></div>
        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.4em] text-erf-gold">Error · 404</div>
          <h1 className="mt-3 font-display font-bold text-4xl">Route not found</h1>
          <p className="mt-3 font-nav text-erf-cream/70">
            The path <span className="font-mono text-erf-gold">{location.pathname}</span> does not resolve to any surface in ERF ConstructionOS.
          </p>
        </div>

        {suggestions.length > 0 && (
          <div className="bg-erf-darkSurface border border-erf-darkBorder rounded-md p-4 text-left" data-testid="not-found-suggestions">
            <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-erf-cream/60 mb-3">
              <Search className="w-3.5 h-3.5 text-erf-gold" /> Did you mean…
            </div>
            <ul className="space-y-2">
              {suggestions.map((r) => (
                <li key={r.path}>
                  <Link
                    to={r.path}
                    data-testid={`nf-suggest-${r.path.replace(/\//g,"-")}`}
                    className="flex items-center justify-between p-2 rounded hover:bg-erf-cream/5 transition-colors"
                  >
                    <div>
                      <div className="font-nav text-sm text-erf-cream">{r.title}</div>
                      <div className="font-mono text-[10px] text-erf-cream/50">{r.path}</div>
                    </div>
                    <ArrowRight className="w-4 h-4 text-erf-gold" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="flex flex-wrap gap-3 justify-center">
          <Link to={homePath} data-testid="nf-go-home">
            <Button className="bg-erf-gold text-erf-dark hover:bg-erf-goldHover">
              <Home className="w-4 h-4 mr-2" /> {user ? "Owner Command Center" : "Return home"}
            </Button>
          </Link>
          {user && (
            <Link to="/help" data-testid="nf-help">
              <Button variant="outline" className="bg-transparent text-erf-cream border-erf-cream/30 hover:bg-erf-cream/10">
                <BookOpen className="w-4 h-4 mr-2" /> Help Center
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
